import { ACCESS_TYPE_FLOW } from '@/js/constants';
import tasks from '@/js/tasks';
import BiDatasetService from '@/apps/data-platform/services/visualization/bi_dataset_service';
import BiReportService from '@/apps/data-platform/services/visualization/bi_report_service';
import DatastudioReportService from '@/apps/data-platform/services/visualization/datastudio_report_service';
import MyPendingsService from '@/apps/data-platform/services/tables_views/my_pendings_service';
import TableauDashboardService from '@/apps/data-platform/services/visualization/tbl_dashboard_service';
import TableauDatasourceService from '@/apps/data-platform/services/visualization/tbl_datasource_service';
export var massiveSelectRequestsMixin = {
  data: function data() {
    return {
      DIALOG_ADD_ACCESS_REQUEST: 'DIALOG_ADD_ACCESS_REQUEST',
      DIALOG_ADD_CHANGE_METADATA: 'DIALOG_ADD_CHANGE_METADATA',
      DIALOG_CONFIRM_MASSIVE_APPROVE: 'DIALOG_CONFIRM_MASSIVE_APPROVE',
      multipleSelect: false,
      rows_selected: [],
      keyTable: 0
    };
  },
  methods: {
    findItemIndex: function findItemIndex(item) {
      var idFieldName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'document_id';
      return this.rows_selected.findIndex(function (element) {
        return element[idFieldName] === item[idFieldName];
      });
    },
    onItemSelected: function onItemSelected(event, item, callbackAccess, typeFlow) {
      if (!event) {
        var indexOfItem = this.findItemIndex(item, 'id_firestore');
        if (indexOfItem !== -1) {
          this.rows_selected.splice(indexOfItem, 1);
        }
      } else {
        if (typeFlow == ACCESS_TYPE_FLOW.CHANGE_METADATA) {
          callbackAccess(item, this.DIALOG_ADD_CHANGE_METADATA);
        } else {
          callbackAccess(item, this.DIALOG_ADD_ACCESS_REQUEST);
        }
      }
      this.keyTable += 1;
    },
    onRemoveItem: function onRemoveItem(item) {
      var indexOfItem = this.findItemIndex(item, 'id_firestore');
      if (indexOfItem !== -1) {
        this.rows_selected.splice(indexOfItem, 1);
      }
      this.keyTable += 1;
    },
    onAddItem: function onAddItem(item) {
      this.$emit("onItemAdded", {});
      this.rows_selected.push(item);
      this.keyTable += 1;
      this.$refs[this.DIALOG_ADD_ACCESS_REQUEST].onClose();
    },
    massiveApprove: function massiveApprove(type) {
      var _this = this;
      var type_flow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var service = null;
      var callbackReload = null;
      switch (type) {
        case 1:
          service = MyPendingsService;
          callbackReload = this.reloadList;
          break;
        case 2:
          service = TableauDatasourceService;
          callbackReload = this.reloadDataSource;
          break;
        case 3:
          service = TableauDashboardService;
          callbackReload = this.reloadWorkBook;
          break;
        case 4:
          service = BiDatasetService;
          callbackReload = this.reloadDataset;
          break;
        case 5:
          service = BiReportService;
          callbackReload = this.reloadReport;
          break;
        case 6:
          service = DatastudioReportService;
          callbackReload = this.reloadReport;
          break;
      }
      if (this.rows_selected.length == 0) {
        tasks.toast.error("Debe seleccionar al menos un registro.");
        return;
      }
      var params = {
        type: type_flow != null ? type_flow : ACCESS_TYPE_FLOW.ACCESS,
        requests: this.rows_selected
      };
      return service.massiveApprove(params).then(function (response) {
        _this.rows_selected = [];
        var data = response.data;
        var message = _this.translate('success_messages.operation_success');
        if (data.background) {
          message = _this.translate('success_messages.general_processing');
        }
        tasks.toast.success(message);
      }).catch(function (err) {
        console.log(err);
        tasks.toast.error(_this.translate('error_messages.error_general'));
      }).finally(function () {
        callbackReload();
      });
    },
    getRowsSelected: function getRowsSelected() {
      return this.rows_selected;
    }
  },
  watch: {
    multipleSelect: function multipleSelect(oldValue, newValue) {
      if (newValue !== oldValue) {
        this.$emit('toggle');
      }
    },
    rows_selected: function rows_selected(newValue, oldValue) {
      var select = false;
      if (newValue.length > 0) {
        select = true;
      }
      this.$emit('toggle', select);
    }
  }
};